<template>
  <div
    v-if="opened.length > 0"
    class="side-box"
    :class="{ active: opened.length > 0 }"
  >
    <span class="side-box__overlay" />
    <div
      class="side-box__inner"
      :class="{
        opened: opened.indexOf('editNotifications') >= 0,
        'last-active': opened.indexOf('editNotifications') == opened.length - 1
      }"
    >
      <div
        class="side-box__header d-flex justify-content-between align-items-center"
      >
        <div class="atom-back atom-back--gray">
          <div
            class="atom-back__inner d-flex align-items-center"
            @click="closeBox('editNotifications')"
          >
            <img src="@/assets/icons/arrows/arr-gray-left.svg" /><span>{{
              $t("zpet")
            }}</span>
          </div>
        </div>
      </div>
      <div class="side-box__title">
        <h2>
          {{ $t("Nastavení notifikací") }}
          {{ this.item.email }}
        </h2>
      </div>
      <div class="mt-3">
        <notifications-register
          v-if="this.item.register"
          :item="this.item"
          class="col-12 col-sm-10"
          @switch="loadNotifications"
        />
      </div>
      <div class="side-box__content">
        <div
          v-if="this.item.enabled"
          class="row side-box__row d-flex align-items-center mt-3"
        >
          <a
            :class="{ opened: limitsInOpened }"
            class="atom-form-group__toggler mb-2"
            @click="limitsInOpened = limitsInOpened ? false : true"
          >{{ $t("LIMIT_MSG_FROM_DEV")
          }}<img
            src="@/assets/icons/arrows/arr-orange-down.svg"
            class="atom-form-group__toggler__arrow"
          /></a>

          <div
            class="atom-form-group__content mb-3"
            :class="{ opened: limitsInOpened }"
          >
            <div
              v-for="notification in this.item.notifications"
              :key="'i' + notification.notificationId"
              class="col-12"
            >
              <span v-if="limitInIds.indexOf(notification.notificationId) >= 0">
                <notifications-switch
                  :item="notification"
                  :from-profile="fromProfile"
                  :customer="item.customer"
                  :email="item.email"
                />
              </span>
            </div>
          </div>

          <a
            :class="{ opened: limitsOutOpened }"
            class="atom-form-group__toggler mb-2"
            @click="limitsOutOpened = limitsOutOpened ? false : true"
          >{{ $t("LIMIT_MSG_TO_DEV")
          }}<img
            src="@/assets/icons/arrows/arr-orange-down.svg"
            class="atom-form-group__toggler__arrow"
          /></a>

          <div
            class="atom-form-group__content mb-3"
            :class="{ opened: limitsOutOpened }"
          >
            <div
              v-for="notification in this.item.notifications"
              :key="'o' + notification.notificationId"
              class="col-12"
            >
              <span
                v-if="limitOutIds.indexOf(notification.notificationId) >= 0"
              >
                <notifications-switch
                  :item="notification"
                  :from-profile="fromProfile"
                  :customer="item.customer"
                  :email="item.email"
                />
              </span>
            </div>
          </div>
          <a
            :class="{ opened: limitsOtherOpened }"
            class="atom-form-group__toggler mb-2"
            @click="limitsOtherOpened = limitsOtherOpened ? false : true"
          >{{ $t("Ostatní limity")
          }}<img
            src="@/assets/icons/arrows/arr-orange-down.svg"
            class="atom-form-group__toggler__arrow"
          /></a>

          <div
            class="atom-form-group__content"
            :class="{ opened: limitsOtherOpened }"
          >
            <div
              v-for="notification in this.item.notifications"
              :key="'a' + notification.notificationId"
              class="col-12"
            >
              <span
                v-if="
                  limitOutIds.indexOf(notification.notificationId) <= -1 &&
                    limitInIds.indexOf(notification.notificationId) <= -1
                "
              >
                <notifications-switch
                  :item="notification"
                  :from-profile="fromProfile"
                  :customer="item.customer"
                  :email="item.email"
                />
              </span>
            </div>
          </div>
        </div>
        <div v-else>
          <app-loader v-if="item.loading" class="mt-3" />
          <div v-if="!item.loading" class="mt-3">
            {{ $t("Nemáte zapnuté notifikace pro tohoto zákazníka.") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import NotificationsSwitch from "@/components/notifications/switch.vue";
import NotificationsRegister from "@/components/notifications/register.vue";
import Loader from "@/components/loader.vue";

export default {
  components: {
    "notifications-switch": NotificationsSwitch,
    "notifications-register": NotificationsRegister,
    "app-loader": Loader
  },
  props: {
    item: Object,
    fromProfile: Boolean,
    opened: Array
  },
  data() {
    return {
      limitInIds: [1, 3, 5, 7, 9],
      limitOutIds: [2, 4, 6, 8, 10],
      limitsInOpened: true,
      limitsOutOpened: true,
      limitsOtherOpened: true
    };
  },
  computed: {},
  watch: {
    project() {},
    opened() {},
    apiUser() {
      this.loadNotifications();
    }
  },
  mounted() {
    this.item.loading = false;
    console.log("test2");
    console.log("edit notification items >>", this.item);
  },
  methods: {
    openBox(box) {
      this.$emit("openBox", box);
    },
    closeBox(box) {
      if (box == undefined) {
        this.resetValues();

        this.$emit("closeBox");
      } else {
        this.$emit("closeBox", box);
      }
      this.$emit("reload", this.item);
    },
    loadNotifications() {
      this.item.enabled = false;
      this.item.loading = true;
      let promises = [];
      this.$store.commit(
        "modals/setWaitingLoader",
        this.$t("Ukládám data, čekejte prosím...")
      );
      promises.push(
        axios
          .get(
            process.env.VUE_APP_API +
              "/notifications?email[eq]=" +
              encodeURIComponent(this.item.email) +
              "&customerId[eq]=" +
              this.item.customer.customerId,
            {}
          )
          .then(result => {
            result.data.data.forEach(notification => {
              console.log(notification, "TESTT");
              this.item.notifications = notification.notifications;
              this.item.notifications.email = this.item.email;
              this.item.enabled = true;
              this.loading = false;
            });
          })
          .catch(() => {
            this.loading = false;
          })
      );
      return Promise.all(promises).then(() => {
        this.item.loading = false;
        this.$store.commit("modals/setWaitingLoader", "");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
